module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_proceso_productivo.b09b09c6.jpg";